var site = site || {};

site.device = {};
site.window = {};
site.owl = {};
site.nav = {};
site.sidebar = {};
site.search = {};
site.hero = {};

site.device.isTouch = function() {
	try {
		document.createEvent("TouchEvent");
		return true;
	} catch (e) {
		return false;
	}
};

site.window.scrollPosition = 0;

// Shorthand to init owlcarousel
site.owl.init = function(id, options) {
	var $owl = $(id);
	if ($owl.length > 0) {
		$owl.owlCarousel(options);
	}
};

// Init navigation scripts
site.nav.init = function() {
	// Add expand link to mobile menu
	$('.children', '#mainmenu').prepend('<a class="expand" href="#"><i class="fa fa-angle-down"></i></a>');
	$('.selectedLevel1','#mainmenu').addClass('down');
	$('.selectedLevel2','#mainmenu').addClass('down');
	$('.selectedLevel3','#mainmenu').addClass('down');
	site.nav.bind();
	site.nav.submenu();
};

site.nav.submenu = function() {
	$('>a','#mainmenu .level1.children').click(function(e) {
		if ($('body').width() < 992 || $('body').hasClass('stillingar')) return;
		if (!$('body').hasClass('sub2')) {
			e.preventDefault();
			$(this).parent().addClass('selectedLevel1');
			$('body').addClass('sub2');
		}
	});
	$('.level2.children','#mainmenu').click(function(e) {
		if ($('body').width() < 992 || $('body').hasClass('stillingar')) return;
		if (!$('body').hasClass('sub3') || !$(this).hasClass('active')) {
			e.preventDefault();
			$('.level2','#mainmenu').removeClass('active');
			$(this).addClass('active');
			var $level3 = $('.mmLevel3', $(this));
			$('#menuBg').height($level3.outerHeight(true));
			$('body').addClass('sub3');
		}
	});
};

// Bind events
site.nav.bind = function() {
	// Mobile menu toggle
	$('#mainmenuToggle').click(function(e) {
		var menuOpen = $('body').hasClass('mainmenu-open');
		if (!menuOpen) {
			site.window.scrollPosition = $(window).scrollTop();
		}
		site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);
		e.preventDefault();
	});

	// Expand in mobile menu
	$('.expand', '#mainmenu').bind('click', function(e) {
		e.preventDefault();
		var $this = $(this);
		$this.closest('li').toggleClass('down');
	});
};

// Toggle mobile menu
site.nav.mobileToggle = function(e, menuOpen, scrollPosition) {
	$('body').toggleClass('mainmenu-open');
	$(this).toggleClass('open');
	if (!menuOpen) {
		$(window).scrollTop(0);
		$('i', '#mainmenuToggle').removeClass('fa-bars').addClass('fa-close');
	}
	else {
		$(window).scrollTop(scrollPosition);
		$('i', '#mainmenuToggle').removeClass('fa-close').addClass('fa-bars');
	}
};

// Append language to mobilemenu
site.nav.appendLanguage = function() {
	var $divisions = $('.menu', '#divisions');
	var $menu = $('ul.mmLevel1', '#mMenu');

	var $html = $('<li class="ele-language si level1"></li>');
	$divisions.find('li').each(function() {
		var $li = $(this).clone();
		$html.append($li.find('a'));
	});

	$menu.append($html);
};

site.search.init = function () {
	$('#searchToggle').on('click', function (e) {
		e.preventDefault();
		$('body').toggleClass('search-open');

		if ($('body').hasClass('search-open')) {
			$('i', '#searchToggle').removeClass('fa-search').addClass('fa-close');
			$('#q').focus();
		}
		else {
			$('i', '#searchToggle').removeClass('fa-close').addClass('fa-search');
		}
	});
};

site.nav.minar = function() {
	$('.minar .boxTitle h3', '#qn').on('click', function (e) {
		$('body').toggleClass('minar-open');

		$('body.minar-open').on('click', function (e) {
			if (!$(e.target).parents('.minar').length) {
				$('body').removeClass('minar-open');
			}
		});
	});
};

/*
iWebReader
 */
site.iWebReader = {
	init: function() {
		if ($('body').hasClass('noiw') || $('body').hasClass('admin')) return;

		$('#main .box .boxTitle').append(
			'<div id="webreaderContainer"></div>'+'<div id="webreader-root"></div>')
		.each(function() {
			window.WebreaderAsyncInit = function() {
				voiceID = 35;
				voiceRate = 100;
				voiceVolume = 100;
				options = {
					shadow:0,
					playerMode:1,
					scrollMode:0,
					lang:"is",
					bgColor:"#FFFFFF",
					btnColor:"#000000",
					borColor:"#CCCCCC",
					alpha:100,
					download:0,
					parentId:"webreaderContainer",
					soundUrl:escape("http://www.ivona.com/online/fileWebRead.php"+
					"?v="+voiceID+
					"&pv="+voiceVolume+
					"&pr="+voiceRate+
					"&i=nWnaDGxLlzckCNfI"+
					"&di=main"+
					"&sdc=button,cancel,submit,back,silent"+
					"&sdi=fyrirspurnir"+
					"&u="+escape(document.location.href))
				};
				Webreader.create(options, 22 /* Height */);
			};
			(function(){
				//Please Do NOT change or modify this function
				ts=new Date().getTime();
				window.WebreaderAutoCreate = 0;
				e = document.createElement("script");
				e.async = true;
				if("https:" == document.location.protocol){
					e.src = "https://secure.iwebreader.com/static/scripts/webreaderPlayer2.js?timestamp="+ts
				}else{
					e.src = "http://static.iwebreader.com/wr/scripts/webreaderPlayer2.js?timestamp="+ts
				}
				document.getElementById("webreader-root").appendChild(e)
			}());
		});
	}
}

/*
 Frontpage
 */
site.frontpage = {
	init: function () {
		if (!$('body').hasClass('frontpage')) return;
		
		/* Banner */
		if ($('#hero li').length > 0 && !$('body').hasClass('stillingar')) {
			site.owl.init('#hero > ul', {
				loop:true,
				dots:true,
				nav:false,
				items:1,
				navText:["",""],
				stopOnHover:true,
				autoplay:true,
				autoplayTimeout:8000,
				autoplayHoverPause:true,
				animateOut: 'fadeOut',
				animateIn: 'fadeIn',
				onDrag:function() {
					$('#hero .owl-controls').hide();
				},
				onDragged:function() {
					$('#hero .owl-controls').show();
				}
			});
		}
	},
	hero: function() {
		if (!$('body').hasClass('frontpage')) return;
		$('#hero li').css('min-height',0);
		$('#hero li').maxHeight();
	}
};

/*
 Calendar
 */
site.calendar = {
	init: function () {
		if (!$('body').hasClass('frontpage') && !$('body').hasClass('calendar')) return;
		$(".eventList li").each(function() {
			var $this = $(this);
			$this.click(function() {
				location.href = $("h2 a",this).attr("href");
			});
		});
	}
};

// Run all the inits \o/
$(function() {
	site.nav.init();
	site.search.init();
	site.nav.minar();
	site.iWebReader.init();
	site.frontpage.init();
	site.calendar.init();
	/*
	site.owl.init('#reviews > ul', {
		loop:true,
		nav:true,
		navText:["",""],
		items: 1
	});
	*/


	// Responsive vimeo player
	//var $i = $('iframe', '#center');
	//if ($i.length > 0 && $i.attr('src').indexOf('player.vimeo.com') != -1) {
	//	$i.wrap('<div class="vimeoPlayer"></div>');
	//}

	// Responsive tables
	$('table', '#center').wrap('<div class="responsiveTable"></div>');

	// Touch login
	$('.login').bind('click', function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	$li = $('.selected', '#divisions');
	$ul = $('.menu', '#divisions');
	$ul.prepend($li);
});

$.fn.maxHeight = function(){
	return this.css('min-height',Math.max.apply(this, $.map( this , function(e){ return $(e).outerHeight() })));
};

$(window).load(function () {
	site.frontpage.hero();
});
$(window).resize(function () {
	site.frontpage.hero();
});